import React from 'react';
import PropTypes from 'prop-types';
import {
  getTransferCity,
  getTransferDuration,
  getTransferDates,
  getHoursSafe,
} from '../../utils/flightUtils';

import Icon from '../../../../../../components/Icon';
import FlightDaysDiff from './FlightDaysDiff';

const baseCls = 'checkout-flight-route-hint';

const FlightTransferInfo = ({ transition, transitionTime, className }) => {
  const city = getTransferCity(transition);
  const duration = getTransferDuration(transitionTime);
  const { arrival, departure } = getTransferDates(transitionTime);
  return (
    <div className={className}>
      {duration && <span style={{ fontWeight: 'bold' }}>{duration}</span>}
      {duration && city && ' — '}
      {city}
      <br />
      <Icon type="plane-arrival" className={`${baseCls}__icon-arrival`} />
      {arrival && departure
        ? `${getHoursSafe(arrival)}−${getHoursSafe(departure)}`
        : null}
      <FlightDaysDiff
        className={`${baseCls}__diff`}
        previousDate={arrival}
        nextDate={departure}
      />
      <Icon type="plane" className={`${baseCls}__icon-departure`} />
    </div>
  );
};

FlightTransferInfo.defaultProps = {
  className: '',
};
FlightTransferInfo.propTypes = {
  transition: PropTypes.shape({
    city: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
  transitionTime: PropTypes.shape({
    arrival: PropTypes.string,
    departure: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
};

export default FlightTransferInfo;
